import Vue from "vue";
import Vuetify from "vuetify/lib";
import VueSweetalert2 from "vue-sweetalert2";
import ReactiveProvide from "vue-reactive-provide";
// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(VueSweetalert2);
Vue.use(Vuetify);
Vue.use(ReactiveProvide, {
  name: "reactiveProvide",
});

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#ff6214",
      },
    },
  },
});
